import React from 'react';
import classes from "./ComprehensiveSupport.module.css";
import { Col, Container, Row } from 'react-bootstrap';
import Image from "../../../assets/images/comprehensive-support.jpg";
import { ComprehensiveData } from '../../../data/app-data';

export default function ComprehensiveSupport() {
  return (
    <Container>
      <Row className={`gy-3 ${classes.rowClass}`}>
        <Col lg={7} md={12}>
          <p className="f-45 fw-600">
            <span className="highlightedText">Comprehensive</span> Support for Tribal Lending & <span className="highlightedText">E-Commerce</span> Boards
          </p>

          <p className="f-16 fw-400 mt-3">
            Tribal Reg. provides essential governance and oversight functions for tribal lending and e-commerce boards, ensuring regulatory effectiveness and operational integrity. Our support includes:
          </p>

          <ul className={`${classes.pointsDiv} mt-4`}>
            {ComprehensiveData?.map((section, i) => (
              <li key={i} className="mb-3">
                <p className="f-18 fw-600 mb-2">{section.section}</p>
                <ul className="ms-3">
                  {section.items.map((item, j) => (
                    <li key={j} className={`f-15 fw-300 ${classes.list} ${classes.hyphenList}`}>
                      {item}
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </Col>

        <Col lg={5} md={12}>
          <div className={classes.imageDiv}>
            <img src={Image} alt="img" className={classes.image} />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

